import React, { useEffect, useState } from "react";
import Select from "react-select";
import Http from "../../../Common/Http";

const ReceipeDetail = (props) => {
  const [unit, setUnit] = useState();
  const removeList = (index) => {
    props.remove(index);
  };
  const fetchUnitData = async (id) => {
    const response = await Http.get(`/product/${id}`);
    setUnit(response.data)
  }

  useEffect(()=>{
    fetchUnitData(props.listInfo?.product?.id);
  },[])

  const handleInputChange = (e, index) => {
    props.listInputChange(e, index);
  };
  return (
    <tr>
      <td>{props.listInfo?.product?.code}</td>
      <td>
        {props.listInfo?.product?.name ? props.listInfo?.product?.name : props.listInfo?.product}
      </td>
      <td className="text-right">
        <p style={{ padding: "7px 0px", marginBottom: "0px" }}>
          {props.listInfo.stndrd_qty ? props.listInfo.stndrd_qty : 0}
        </p>
      </td>
      <td>
        <div className="input-group mb-3">
          <input
            type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
            className="form-control"
            name="issue_qty"
            onChange={(e) => handleInputChange(e, props.listSl)}
            value={
              props.listInfo.qty || ""
            }
          />
          <span className="input-group-text">{unit?.unit?.name}</span>
        </div>
      </td>
      {/* <td>
        {props.listDetail.length > 0 ? (
          props.listDetail[props.listSl]
        ) : (
          ""
        )}
      </td> */}
      {/* <td className="text-center">
        <button
          className="btn btn-danger btn-sm"
          onClick={() => removeList(props.listSl)}
        >
          <i className="fa fa-trash"></i>
        </button>
      </td> */}
    </tr>
  );
};

export default ReceipeDetail;
